import React, { Component } from 'react'
import ReactGA from 'react-ga'

import Header from '../molecules/Header'
import ProgressBar from '../molecules/ProgressBar'
import { LinkedServicesSelector } from '../organisms/ServicesSelector'
import { BottomBar } from '../molecules/BottomBar'
import { Content } from '../atoms/Content'
import { LinkedChooseServiceButton } from '../atoms/ChooseServiceButton'
import { Grid } from '@material-ui/core'
import ServicesDescription from '../molecules/ServicesDescription'

export class Services extends Component {
  componentDidMount() {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  render() {
    return (
      <div>
        <Header />
        <ProgressBar activeStep={this.props.activeStep} />
        <Content>
          <Grid container spacing={16}>
            <Grid item xs={12} md={6}>
              <ServicesDescription />
            </Grid>
            <Grid item xs={12} md={6}>
              <LinkedServicesSelector />
            </Grid>
          </Grid>
        </Content>
        <BottomBar>
          <LinkedChooseServiceButton />
        </BottomBar>
      </div>
    )
  }
}
